import {defineAsyncComponent} from 'vue';
import {upperFirst} from './helpers';

// Glob import all Base*.vue or Base*.js components
const components = import.meta.glob('../components/base-components/Base*.{vue,js}');

// Голая функция-лоадер стала бы функциональным компонентом — оборачиваем в defineAsyncComponent.
export function installBaseComponents(app) {
  Object.entries(components).forEach(([path, componentLoader]) => {
    const fileName = path.split('/').pop();
    const componentName = upperFirst(fileName.replace(/\.\w+$/, ''));

    app.component(componentName, defineAsyncComponent(componentLoader));
  });
}
